import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Home from "@/pages/Home";
import AreaPage from "@/pages/AreaPage";
import { scrollToHash, scrollToTop } from "@/lib/scroll";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => {
      if (!scrollToHash(hash)) scrollToTop();
    }, 140);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onHash = () => scrollToHash();
    window.addEventListener("hashchange", onHash);
    const onLoad = () => scrollToHash();
    window.addEventListener("load", onLoad);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("hashchange", onHash);
      window.removeEventListener("load", onLoad);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/area/:slug" element={<AreaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
